module.exports = __webpack_public_path__ + "static/media/download-google-store.69d8da1c.svg";